/*! Version: 11.5.3 , Build Number: 268 , Commons Version: 5.5.0 ,!!  */
"use strict";
(self["webpackChunkweb_manage_my_booking"] = self["webpackChunkweb_manage_my_booking"] || []).push([["node_modules_commercial-management--digital--web-components-design--library_dist_common-0F4QzDz__js"],{

/***/ 41873:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "APPLY_TEXT": () => (/* binding */ E),
/* harmony export */   "BTN_ACCEPT": () => (/* binding */ T),
/* harmony export */   "BTN_ACCEPT_AND_EXIT": () => (/* binding */ _),
/* harmony export */   "BTN_ACCEPT_CONTINUE": () => (/* binding */ N),
/* harmony export */   "BTN_SAVE_AND_CONTINUE": () => (/* binding */ A),
/* harmony export */   "CONTINUE": () => (/* binding */ O),
/* harmony export */   "DATA_BEING_VALIDATED": () => (/* binding */ R),
/* harmony export */   "DATA_PROCESSING": () => (/* binding */ o),
/* harmony export */   "DATA_VALIDATED_AND_SAVED": () => (/* binding */ t),
/* harmony export */   "FORM_COMPLETE_FIELD_ERROR": () => (/* binding */ M),
/* harmony export */   "FORM_EXPIRY_DATE_ERROR": () => (/* binding */ n),
/* harmony export */   "FREE_LABEL": () => (/* binding */ c),
/* harmony export */   "GENERAL_FREE_LABEL": () => (/* binding */ s),
/* harmony export */   "IMPORTANT_ANNOUNCEMENT": () => (/* binding */ I),
/* harmony export */   "INPUT_REQUIRED_ERROR": () => (/* binding */ D),
/* harmony export */   "LOADING_TEXT": () => (/* binding */ a),
/* harmony export */   "MANDATORY": () => (/* binding */ C),
/* harmony export */   "MONTH_APRIL": () => (/* binding */ B),
/* harmony export */   "MONTH_AUGUST": () => (/* binding */ L),
/* harmony export */   "MONTH_DECEMBER": () => (/* binding */ P),
/* harmony export */   "MONTH_FEBRUARY": () => (/* binding */ U),
/* harmony export */   "MONTH_JANUARY": () => (/* binding */ H),
/* harmony export */   "MONTH_JULY": () => (/* binding */ i),
/* harmony export */   "MONTH_JUNE": () => (/* binding */ r),
/* harmony export */   "MONTH_MARCH": () => (/* binding */ e),
/* harmony export */   "MONTH_MAY": () => (/* binding */ S),
/* harmony export */   "MONTH_NOVEMBER": () => (/* binding */ d),
/* harmony export */   "MONTH_OCTOBER": () => (/* binding */ Y),
/* harmony export */   "MONTH_SEPTEMBER": () => (/* binding */ G),
/* harmony export */   "OPTIONAL": () => (/* binding */ F),
/* harmony export */   "TERMS_AND_CONDITIONS_TEXT": () => (/* binding */ V),
/* harmony export */   "default": () => (/* binding */ l)
/* harmony export */ });
const E = "Aplicar",
  T = "Aceptar",
  N = "Aceptar y continuar",
  _ = "Aceptar y salir",
  A = "Guardar y continuar",
  O = "Continuar",
  R = "Validando datos…",
  o = "Tratamiento de datos",
  t = "Datos válidos y guardados",
  M = "Completa este campo",
  n = "Indica la fecha de caducidad",
  c = "Gratis",
  s = "Gratis",
  I = "Aviso importante",
  D = "Este campo es obligatorio",
  a = "Cargando",
  C = "(obligatorio)",
  B = "ABRIL",
  L = "AGOSTO",
  P = "DICIEMBRE",
  U = "FEBRERO",
  H = "ENERO",
  i = "JULIO",
  r = "JUNIO",
  e = "MARZO",
  S = "MAYO",
  d = "NOVIEMBRE",
  Y = "OCTUBRE",
  G = "SEPTIEMBRE",
  F = "(Opcional)",
  V = "Términos y condiciones generales",
  l = {
    APPLY_TEXT: E,
    BTN_ACCEPT: T,
    BTN_ACCEPT_CONTINUE: N,
    BTN_ACCEPT_AND_EXIT: _,
    BTN_SAVE_AND_CONTINUE: A,
    CONTINUE: O,
    DATA_BEING_VALIDATED: R,
    DATA_PROCESSING: o,
    DATA_VALIDATED_AND_SAVED: t,
    FORM_COMPLETE_FIELD_ERROR: M,
    FORM_EXPIRY_DATE_ERROR: n,
    FREE_LABEL: c,
    GENERAL_FREE_LABEL: s,
    IMPORTANT_ANNOUNCEMENT: I,
    INPUT_REQUIRED_ERROR: D,
    LOADING_TEXT: a,
    MANDATORY: C,
    MONTH_APRIL: B,
    MONTH_AUGUST: L,
    MONTH_DECEMBER: P,
    MONTH_FEBRUARY: U,
    MONTH_JANUARY: H,
    MONTH_JULY: i,
    MONTH_JUNE: r,
    MONTH_MARCH: e,
    MONTH_MAY: S,
    MONTH_NOVEMBER: d,
    MONTH_OCTOBER: Y,
    MONTH_SEPTEMBER: G,
    OPTIONAL: F,
    TERMS_AND_CONDITIONS_TEXT: V
  };


/***/ })

}]);